// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root___WqP5","copy-icon":"classes_copy-icon__1iGq4"};